import { useEffect } from 'react';
import NepalMap from './NepalMap';
import './SplashScreen.css';

const SplashScreen = ({ onComplete }) => {
  useEffect(() => {
    const timer = setTimeout(onComplete, 4800);
    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className="splash-overlay" role="status" aria-label="Loading Map Hunt Nepal">
      <div className="splash-bg" />

      <div className="splash-top">
        <span className="splash-welcome">Welcome to</span>

        <h1 className="splash-title">
          {'NEPAL'.split('').map((ch, i) => (
            <span key={i} className="splash-letter" style={{ '--i': i }}>
              {ch}
            </span>
          ))}
        </h1>

        <p className="splash-sub">Map Hunt</p>
      </div>

      <div className="splash-map">
        <NepalMap />
      </div>

      <div className="splash-mountains-wrap">
        <svg
          viewBox="0 0 1440 180"
          preserveAspectRatio="none"
          className="splash-mountains-svg"
          aria-hidden="true"
        >
          {/* back range */}
          <path
            d="M0,180 L0,130 L80,75 L180,115 L320,40 L460,95 L600,50 L740,100 L880,25 L1020,80 L1160,45 L1300,85 L1440,60 L1440,180 Z"
            fill="rgba(20,184,166,0.14)"
          />
          {/* mid range */}
          <path
            d="M0,180 L0,155 L100,105 L220,140 L380,80 L520,125 L660,85 L800,120 L940,65 L1080,110 L1220,78 L1360,105 L1440,88 L1440,180 Z"
            fill="rgba(20,184,166,0.07)"
          />
          {/* front silhouette */}
          <path
            d="M0,180 L0,165 L140,118 L260,150 L420,95 L560,138 L700,100 L840,135 L980,88 L1120,125 L1260,100 L1380,120 L1440,108 L1440,180 Z"
            fill="#0a0d12"
          />
        </svg>
      </div>

      <div className="splash-bar-track">
        <div className="splash-bar-fill" />
      </div>
    </div>
  );
};

export default SplashScreen;